import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LotLookup, SalesState } from './sales.reducer';

// Select the feature slice
export const selectSalesState = createFeatureSelector<SalesState>('salesReducer');
// Select properties from the feature slice
export const selectSalesOffices = createSelector(selectSalesState, state => state.salesOffices);
export const selectAgencies = createSelector(selectSalesState, state => state.agencies);
export const selectSalesOfficesPublic = createSelector(selectSalesState, state => state.salesOfficesPublic);
export const selectSalesAgents = createSelector(selectSalesState, state => state.salesAgents);
export const selectAgencyRealtors = createSelector(selectSalesState, state => state.agencyRealtors);

export const selectProjectLotsState = createSelector(selectSalesState, state => state.projectLots);

export const selectSortedProjectLots = createSelector(selectProjectLotsState, projectLots =>
  [...projectLots.lots].sort((a, b) =>
    a.lotNo.localeCompare(b.lotNo, undefined, { numeric: true, sensitivity: 'base' })
  )
);

export function findAdjacentLots(
  lots: LotLookup[],
  lotId: string | null | undefined
): { previous?: LotLookup; next?: LotLookup } {
  if (!lotId) return {};
  const index = lots.findIndex(lot => lot.id.toLowerCase() === lotId.toLowerCase());
  if (index < 0) return {};
  return {
    previous: index > 0 ? lots[index - 1] : undefined,
    next: index < lots.length - 1 ? lots[index + 1] : undefined
  };
}

export const selectAdjacentLots = (lotId: string | null | undefined) =>
  createSelector(selectSortedProjectLots, lots => findAdjacentLots(lots, lotId));
